<template>
  <div class="common-file-list-item">
    <vs-divider class="m-0"></vs-divider>
    <div class="list-item-contents flex items-center justify-between">
      <div class="file-name flex items-center ml-2" @click="_clickFileName()">
        {{ file.name }}
      </div>
      <div class="flex items-center">
        更新日時： {{ getDateTime(file.uploaded_at) }}

        <div v-show="showRequiredSwitch" class="mr-2">必須</div>
        <feather-icon
          icon="DownloadIcon"
          class="cursor-pointer icon-button mr-2"
          svgClasses="w-6 h-6"
          @click.stop="_downloadFile()"
        ></feather-icon>
        <feather-icon
          icon="Trash2Icon"
          class="cursor-pointer icon-button"
          svgClasses="w-6 h-6"
          @click.stop="_deleteFile()"
        ></feather-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { ColorMixin, HullInsranceMixin } from "@/mixins";
import moment from "moment";

export default {
  mixins: [ColorMixin, HullInsranceMixin],
  props: {
    file: { type: Object, required: true },
    deleteFile: { type: Function },
    downloadFile: { type: Function },
    onClickFileLink: { type: Function },
    showRequiredSwitch: {
      type: Boolean,
      required: false,
      default: false,
    },
    id: {
      type: String,
      required: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    getDateTime(date) {
      return moment(date).format("YYYY-MM-DD HH:mm");
    },

    _downloadFile() {
      const payload = {
        id: this.id,
        name: this.file.name,
        token: this.file.token,
        type: this.file.content_type,
      };
      this.downloadFile(payload);
    },

    _clickFileName() {
      const payload = {
        id: this.id,
        name: this.file.name,
        token: this.file.token,
        type: this.file.content_type,
      };
      this.onClickFileLink(payload);
    },

    _deleteFile() {
      const payload = {
        id: this.id,
        name: this.file.name,
      };
      this.deleteFile(payload);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/hull-insurance.scss";

.common-file-list-item {
  font-family: $aisea-font-family;
  --vs-primary: $aisea-blue;
  cursor: default;

  .vs-divider-border {
    border-top: solid 1px $border-color1 !important;
  }

  .list-item-contents {
    padding: 6px;
    font-size: 12px;
    font-family: $aisea-font-family;
  }
  .file-name {
    color: $aisea-blue;
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
</style>
